import { render } from "./PersonalDetail.vue?vue&type=template&id=b6c4e6ce"
import script from "./PersonalDetail.vue?vue&type=script&lang=js"
export * from "./PersonalDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__